import doRequest from "../helpers";
import { getToken } from "../auth/tokenAuth";
import { getUserId } from "services/storage/general";
import helpers from "./helpers";

export const requestGetAcadReinforceList = async ({
	filterType,
	title,
	date,
	acadReinforceTypeId,
	tutorId,
	locationId,
	campusId,
	page,
}) => {
	const [result, err] = await doRequest(
		`/LeerRefuerzoVisualizacion`,
		"POST",
		{
			tipoFiltro: filterType,
			pagina: page,
			titulo: title,
			fechaBuscar: date,
			idTipoRefuerzo: acadReinforceTypeId,
			idTutor: tutorId,
			idUbicacion: locationId,
			idCampus: campusId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { listaVisualizacionRefuerzo, paraSincronizar } = data.data;
	return {
		acadReinforceList:
			listaVisualizacionRefuerzo?.map(helpers.parseToAcadReinforceItem) ||
			null,
		toSynchronize: paraSincronizar || false,
	};
};
export const requestGetQuantityAcadReinforce = async ({
	title,
	date,
	acadReinforceTypeId,
	tutorId,
	locationId,
	campusId,
}) => {
	const [result, err] = await doRequest(
		`/CantidadListaRefuerzoVisualizacion`,
		"POST",
		{
			titulo: title,
			fechaBuscar: date,
			idTipoRefuerzo: acadReinforceTypeId,
			idTutor: tutorId,
			idUbicacion: locationId,
			idCampus: campusId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const {
		General: general,
		Pasados: past,
		Borrador: draft,
		Cancelados: canceled,
		NoProcesados: unprocessed,
	} = data.data.cantidadesRefuerzo;
	return {
		general,
		past,
		draft,
		canceled,
		unprocessed,
	};
};
export const requestGetAcadReinforceById = async acadReinforceId => {
	const [result, err] = await doRequest(
		`/RefuerzoAcademico/Leer/${acadReinforceId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return helpers.parseToRetrievingAcadReinforceForm(
		data.data.refuerzoFormularioBE
	);
};
export const requestGetMassiveAcadReinforceById = async acadReinforceId => {
	const [result, err] = await doRequest(
		`/RefuerzoAcademicoCargaMasiva/Leer/${acadReinforceId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const {
		idPeticion,
		tipoInstalacion,
		vacantes,
		fecha,
		nroReunion,
		horaInicio,
		horaFin,
		idCampusDetalle,
	} = data.data.edit;
	return {
		requestId: idPeticion,
		meetingId: nroReunion,
		campusDetailId: idCampusDetalle,
		environmentTypeId: tipoInstalacion,
		quantityVacancy: String(vacantes),
		date: fecha,
		timeStart: horaInicio,
		timeEnd: horaFin,
	};
};
export const requestCreateAcadReinforce = async form => {
	const body = {
		codigoUsuario: getUserId(),
		...helpers.parseToAddOrUpdateRequestStep1(form),
	};
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/CargaManual/Crear",
		"POST",
		body,
		getToken()
	);
	if (err) return { newAcadReinforceId: null };
	const { data } = result;
	const { data: dataFetch } = data;
	if (data?.state === 1) {
		return {
			newAcadReinforceId: dataFetch?.idTallerVirtual,
			message: "",
		};
	}
	return {
		newAcadReinforceId: null,
		message: dataFetch?.mensaje,
	};
};
export const requestUpdateAcadReinforceById = async (
	acadReinforceId,
	form,
	step
) => {
	let body = {
		codigoUsuario: getUserId(),
		idTallerVirtual: acadReinforceId,
	};
	if (step === "step1") {
		body = {
			...body,
			...helpers.parseToAddOrUpdateRequestStep1(form),
		};
	} else if (step === "step2") {
		body = {
			...body,
			...helpers.parseToUpdateRequestStep2(form),
		};
	}
	const [result, err] = await doRequest(
		"/Refuerzo/CargaManual/Editar",
		"POST",
		body,
		getToken()
	);
	if (err) return { success: false };
	const { data } = result;
	if (data?.state === 1) return { success: true };
	const { data: dataFetch } = data;
	return {
		success: dataFetch.exito,
		message: dataFetch?.mensaje,
	};
};
export const requestUpdateMassiveAcadReinforceById = async acadReinforce => {
	const {
		id,
		requestId,
		meetingId,
		campusDetailId,
		environmentTypeId,
		quantityVacancy,
		date,
		timeStart,
		timeEnd,
		environment,
	} = acadReinforce;
	const [result, err] = await doRequest(
		"/RefuerzoAcademicoCargaMasiva/Editar",
		"POST",
		{
			idTallerVirtual: id,
			idPeticion: requestId,
			idInstalacion: environment.id,
			tipoInstalacion: environmentTypeId,
			vacantes: parseInt(quantityVacancy),
			nroReunion: meetingId,
			fecha: date,
			horaInicio: timeStart,
			horaFin: timeEnd,
			idCampusDetalle: campusDetailId,
			codigoAmbiente: environment.environmentCode,
			direccion: environment.address,
			capacidadAmbiente: parseInt(environment.capacity),
			piso: environment.floor,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null,
		};
	const { exito, mensaje } = result.data.data;
	return {
		success: exito,
		message: mensaje || null,
	};
};
export const requestDeleteAcadReinforceById = async acadReinforceId => {
	const [result, err] = await doRequest(
		`/Refuerzo/CargaManual/Cancelar`,
		"POST",
		{
			idTallerVirtual: acadReinforceId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};
export const requestFinalizeAcadReinforceDraft = async acadReinforceId => {
	const [result, err] = await doRequest(
		"/Refuerzo/CargaManual/Finalizar",
		"POST",
		{
			idTallerVirtual: acadReinforceId,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (![0, 1].includes(data?.state)) return null;
	return data.data?.mensaje || null;
};
export const requestAcadReinforceExists = async acadReinforceId => {
	if (!acadReinforceId) return false;
	const [result, err] = await doRequest(
		`/RefuerzoAcademicoExiste/${acadReinforceId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.refuerzo;
};
export const requestValidateFileForCreateAcadReinforceMassiveLoading = async fileBase64 => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademicoCargaMasiva/ValidarArchivo",
		"POST",
		{ archivoCargaMasiva: fileBase64 },
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return {
		rowCountFile: data.data.cantidadFilas,
		errorStack: data.data.pilaErrores.map(({ fila, mensaje }) => {
			return { row: fila, message: mensaje };
		}),
	};
};
export const requestCreateAcadReinforceMassiveLoading = async fileBase64 => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademicoCargaMasiva/Crear",
		"POST",
		{
			codigoUsuario: getUserId(),
			archivoCargaMasiva: fileBase64,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result.data;
	if (data.exito)
		return {
			success: true,
		};
	const { fila, mensaje } = data;
	if (fila || mensaje)
		return {
			row: fila || 0,
			message: mensaje || null,
		};
	const { exito, cantERROR, cantOK, pilaErrores } = data;
	return {
		success: exito,
		quantities: {
			ok: cantOK || 0,
			error: cantERROR || 0,
		},
		errorStack:
			pilaErrores?.map(({ fila, codDocente, mensaje }) => ({
				row: fila,
				tutorId: codDocente,
				message: mensaje,
			})) || [],
	};
};
export const requestSyncUnprocessedAcadReinforce = async () => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademicoCargaMasiva/Sincronizar",
		"POST",
		{ codigoUsuario: getUserId() },
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state === 0)
		return {
			message: data.data.mensaje,
		};
	if (data?.state !== 1) return null;
	const { Procesados, NoProcesados, Pendientes } = data.data;
	return {
		processed: Procesados,
		unprocessed: NoProcesados,
		pending: Pendientes,
	};
};
export const requestUserHasAcadReinforce = async (userCode, isTutorUser) => {
	const [result, err] = await doRequest(
		"/UsuarioPorRefuerzoAcademico",
		"POST",
		[userCode, isTutorUser],
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.existe;
};
